import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NoteSearchResultsComponent } from './note-search-results.component';
import { NoResultsLabelModule } from '@fleet/shared';
import { ResponsiveElementModule } from '@fleet/layout';
import { MatTableModule } from '@angular/material/table';
import { InternationalizationDatePipeModule } from '@fleet/internationalization';
import { LineBreakPipeModule, TitleCaseAndCleanPipeModule } from '@fleet/pipes';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { BadgeModule, StatusChipModule } from '@fleet/ui';
import { provideTranslocoScope, TranslocoDirective } from '@jsverse/transloco';

const lazyTranslationloader = ['en_au', 'es', 'en_us'].reduce(
  (acc: { [key: string]: () => Promise<any> }, lang) => {
    acc[lang] = () => import(`./i18n/${lang}.json`);

    return acc;
  },
  {}
);
@NgModule({
  declarations: [NoteSearchResultsComponent],
  imports: [
    CommonModule,
    MatTableModule,
    ResponsiveElementModule,
    NoResultsLabelModule,
    TitleCaseAndCleanPipeModule,

    InternationalizationDatePipeModule,
    LineBreakPipeModule,
    MatMenuModule,
    MatButtonModule,
    StatusChipModule,
    MatIconModule,
    BadgeModule,
    TranslocoDirective,
  ],
  exports: [NoteSearchResultsComponent],
  providers: [
    provideTranslocoScope({
      scope: 'noteSearchResults',
      loader: lazyTranslationloader,
    }),
  ],
})
export class NoteSearchResultsModule {}
